export default __webpack_public_path__ + "static/media/s-1.045aca94.jpg";